import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f25c8dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 's client ")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "audit-grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Timestamp", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Action", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Actioned by", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Note", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("cancel")

import "@/assets/css/action-buttons.css";

import {
  Ref,
  ref,
  withDefaults,
  watch,
  computed,
  onMounted,
} from "vue";
import BaseCommandModal from "../ActionModals/_BaseCommandModal.vue";
import { Button as KButton } from "@progress/kendo-vue-buttons";

import {
  ActionCode,
  ClientCommissionAudit,
  ClientManager,
  ClientManagerItem,
} from "../typesAndConstants";
import ActionResultMessage from "./Components/ActionResultMessage.vue";

import * as api from "../api";

//#endregion
type ModalProps = {
  show?: boolean;
  clientManager: ClientManager;
  model?: ClientManagerItem | null;
};

//#region PROPS

const __default__ = {
  name: "ViewAuditModal",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    clientManager: null,
    model: { default: null }
  },
  emits: ["command-executed", "close-modal"],
  setup(__props: any, { emit }) {

const props = __props as { show: boolean, clientManager: ClientManager, model: ClientManagerItem | null }

//#region IMPORTS

// Global CSS

//#endregion


const strOfActionCode = (actionCode: ActionCode): string => {
  switch (actionCode) {
    case "addNewClient":
      return "Added new client";
    case "changeClientManagerInfo":
        return "Changed Client Manager Group"
    case "changeClientManager":
      return "Changed Client Manager";
    case "changeClientType":
      return "Changed Client Type";
    case "changeTransferredStatus":
      return "Changed transferred status";
    case "recalculateCommissions":
      return "Manually recalculated commission";
    default:
      return `${actionCode}`;
  }
};

const reFormatDateTime = (strDateTime: string): string => {
  const dt = new Date(Date.parse(strDateTime));
  
  return `${dt.getDate()}/${dt.getMonth() + 1}/${dt.getFullYear()} ${dt.getHours()}:${dt.getMinutes()}`;
};
//#region EMITS

//#endregion

const showActionResultMessage = ref(false);
const audit: Ref<ClientCommissionAudit[]> = ref([]);
const errorMessages: Ref<string[]> = ref([]);
const hasError = computed(() => !!errorMessages.value.length);
watch(
  () => props.show,
  async (model, o) => {
    showActionResultMessage.value = false;
    errorMessages.value = [];
    audit.value = props.model
      ? await api.getClientAudit(props.model?.ClientId ?? 0)
      : await api.getClientManagerAudit(props.clientManager?.Id ?? 0);
  },
);

onMounted(async ()=> {
  showActionResultMessage.value = false;
  errorMessages.value = [];
  audit.value = props.model
    ? await api.getClientAudit(props.model?.ClientId ?? 0)
    : await api.getClientManagerAudit(props.clientManager?.Id ?? 0);
});
//#region EVENT HANDLERS
const onCloseModal = (): void => emit("close-modal");
const onCancel = () => emit("close-modal");
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCommandModal, {
    show: props.show,
    title: 'Audit',
    readonly: true,
    onCloseModal: onCloseModal
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.model)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(props.model?.Client), 1),
              _createTextVNode(" (" + _toDisplayString(props.model?.ClientEmail) + "), ", 1),
              _createElementVNode("i", null, _toDisplayString(props.clientManager.FullName.slice(4)), 1),
              _hoisted_3
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("strong", null, _toDisplayString(props.clientManager.FullName.slice(4)) + " manual commissions recalculation audit trail ", 1)
            ])),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.value, (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              key: entry.Id,
              class: "audit-row"
            }, [
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(reFormatDateTime(entry.Timestamp)) + " (GMT)", 1),
              _hoisted_7,
              _createElementVNode("div", null, _toDisplayString(strOfActionCode(entry.Action)), 1),
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(entry.Operator), 1),
              _hoisted_9,
              _createElementVNode("div", null, _toDisplayString(entry.Note), 1)
            ]))
          }), 128))
        ])
      ]),
      (showActionResultMessage.value)
        ? (_openBlock(), _createBlock(ActionResultMessage, {
            key: 0,
            "has-error": _unref(hasError),
            "error-messages": errorMessages.value
          }, null, 8, ["has-error", "error-messages"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(KButton), {
        class: "action no-action",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})